import { IconPropsType } from './types/IconsProps.type';

type GiftIconProps = IconPropsType;

export const GiftIcon = ({
  width = 34,
  height = 32,
  className = '',
  style = {},
  fillColor = 'currentColor',
}: GiftIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 34 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M30.6 6.73684H26.894C27.081 6.21474 27.2 5.64211 27.2 5.05263C27.2 2.25684 24.922 0 22.1 0C20.315 0 18.768 0.909474 17.85 2.27368L17 3.40211L16.15 2.25684C15.232 0.909474 13.685 0 11.9 0C9.078 0 6.8 2.25684 6.8 5.05263C6.8 5.64211 6.919 6.21474 7.106 6.73684H3.4C1.513 6.73684 0.017 8.23579 0.017 10.1053L0 28.6316C0 30.5011 1.513 32 3.4 32H30.6C32.487 32 34 30.5011 34 28.6316V10.1053C34 8.23579 32.487 6.73684 30.6 6.73684ZM22.1 3.36842C23.035 3.36842 23.8 4.12632 23.8 5.05263C23.8 5.97895 23.035 6.73684 22.1 6.73684C21.165 6.73684 20.4 5.97895 20.4 5.05263C20.4 4.12632 21.165 3.36842 22.1 3.36842ZM11.9 3.36842C12.835 3.36842 13.6 4.12632 13.6 5.05263C13.6 5.97895 12.835 6.73684 11.9 6.73684C10.965 6.73684 10.2 5.97895 10.2 5.05263C10.2 4.12632 10.965 3.36842 11.9 3.36842ZM30.6 28.6316H3.4V25.2632H30.6V28.6316ZM30.6 20.2105H3.4V10.1053H12.036L8.5 14.8716L11.254 16.8421L15.3 11.3853L17 9.09474L18.7 11.3853L22.746 16.8421L25.5 14.8716L21.964 10.1053H30.6V20.2105Z"
        fill={fillColor}
      />
    </svg>
  );
};
